/*! custom-barra-brindes.js — barra de brindes do carrinho, feita no tema

    Elemento <ep-gift-bar> (bloco blocks/_cart-gift-bar.liquid): degraus de
    brinde configurados no editor e o valor que falta para o proximo. O valor
    base e o do snippet cart-gross-total (total apos descontos, sem o cupom
    do Pix), o mesmo da barra de frete gratis.

    Atualizacao: qualquer escrita em /cart/*.js (do tema ou de apps) agenda
    uma leitura de /cart.js e a barra e redesenhada na hora; nada de
    recarregar secao, nada de piscar.

    Motor de brindes (data-auto-add): a cada leitura do carrinho, compara os
    brindes das faixas atingidas (data-gifts, "reais:variante") com o que ja
    esta no carrinho e faz UMA chamada para adicionar o que falta (linhas
    marcadas com _ep_brinde_faixa) e UMA para tirar o que sobrou. O 100% e o
    desconto automatico "BRINDE" do app ep-cupom-brinde (funcao no servidor,
    metacampo elementopuro.brinde_faixa do produto). Substitui as 4-6 chamadas
    em serie do EG Auto Add to Cart. Um brinde que o cliente tirou a mao nao
    volta ate a faixa ser perdida e atingida de novo; um brinde que ficou sem
    o desconto (preco > 0) sai do carrinho e nao volta na sessao. */

(function () {
  'use strict';

  var ICONE = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  function dinheiro(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function escapar(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* valor base a partir do /cart.js: total apos descontos, somando de volta o cupom do Pix */
  function valorBase(cart, pixCode) {
    var total = cart.total_price || 0;
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (String(a.title || '').toUpperCase() === pixCode) total += a.total_allocated_amount || 0;
    });
    return total;
  }

  var barras = [];
  var ultimoCart = null;

  class EpGiftBar extends HTMLElement {}

  EpGiftBar.prototype.connectedCallback = function () {
    this.posicionarNaPagina();
    this.tiers = String(this.dataset.tiers || '').split(',').map(Number).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    this.pixCode = String(this.dataset.pixCode || 'PIX').toUpperCase();
    this.textoEl = this.querySelector('.ep-gift-bar__text');
    this.fillEl = this.querySelector('.ep-gift-bar__fill');
    this.stepsEl = this.querySelector('.ep-gift-bar__steps');
    this.montarDegraus();
    if (barras.indexOf(this) < 0) barras.push(this);
    var inicial = ultimoCart ? valorBase(ultimoCart, this.pixCode) : Number(this.dataset.value || 0);
    this.desenhar(inicial);
  };
  EpGiftBar.prototype.disconnectedCallback = function () {
    var i = barras.indexOf(this);
    if (i >= 0) barras.splice(i, 1);
  };

  /* pagina /cart: o tema monta as duas colunas (cart-page__content e cart-page__summary)
     por JS, e a barra, sendo um bloco solto, ficaria acima delas em largura total.
     Aqui ela vai para a coluna escolhida no editor (data-page-slot); se as colunas
     ainda nao existem, espera por elas. Na gaveta nao ha cart-page e nada acontece. */
  EpGiftBar.prototype.posicionarNaPagina = function () {
    var slot = this.dataset.pageSlot;
    if (!slot || slot === 'top' || this.dataset.posicionada) return;
    var pagina = this.closest('cart-component.cart-page');
    if (!pagina) return;
    var barra = this;
    function mover() {
      var coluna = pagina.querySelector(slot === 'summary' ? '.cart-page__summary' : '.cart-page__content');
      if (!coluna) return false;
      barra.dataset.posicionada = '1';
      var titulo = slot === 'content' ? coluna.querySelector(':scope > .cart-heading') : null;
      if (titulo) titulo.after(barra);
      else coluna.prepend(barra);
      return true;
    }
    if (mover()) return;
    var obs = new MutationObserver(function () { if (mover()) obs.disconnect(); });
    obs.observe(pagina, { childList: true });
    setTimeout(function () { obs.disconnect(); }, 8000);
  };

  EpGiftBar.prototype.montarDegraus = function () {
    if (!this.stepsEl) return;
    var n = this.tiers.length;
    var rotulo = this.dataset.label || 'R$ [valor]+';
    var html = '';
    for (var i = 0; i < n; i++) {
      var pos = n > 1 ? (i / (n - 1)) * 100 : 50;
      var valor = (this.tiers[i] / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      html += '<li class="ep-gift-bar__step" style="--ep-gb-pos:' + pos.toFixed(3) + '%">' +
        '<span class="ep-gift-bar__icon">' + ICONE + '</span>' +
        '<span class="ep-gift-bar__num">' + (i + 1) + '</span>' +
        '<span class="ep-gift-bar__label">' + escapar(rotulo.replace('[valor]', valor)) + '</span>' +
        '</li>';
    }
    this.stepsEl.innerHTML = html;
    this.stepEls = Array.prototype.slice.call(this.stepsEl.children);
  };

  EpGiftBar.prototype.desenhar = function (valor) {
    var n = this.tiers.length;
    if (!n) return;
    var atingidos = 0;
    for (var i = 0; i < n; i++) if (valor >= this.tiers[i]) atingidos = i + 1;
    var completo = atingidos >= n;

    /* preenchimento: ate o ultimo degrau atingido, mais a fracao ate o proximo */
    var pct;
    if (completo) pct = 100;
    else if (n === 1) pct = Math.min(100, (valor / this.tiers[0]) * 100);
    else {
      var base = atingidos > 0 ? (atingidos - 1) / (n - 1) : 0;
      var de = atingidos > 0 ? this.tiers[atingidos - 1] : 0;
      var ate = this.tiers[atingidos];
      var fracao = atingidos > 0 ? Math.max(0, Math.min(1, (valor - de) / (ate - de))) : 0;
      pct = (base + fracao / (n - 1)) * 100;
    }
    if (this.fillEl) this.fillEl.style.width = pct.toFixed(2) + '%';

    this.stepEls.forEach(function (el, i) {
      el.classList.toggle('is-reached', i < atingidos);
      el.classList.toggle('is-next', i === atingidos);
    });

    if (this.textoEl) {
      if (completo) {
        this.textoEl.innerHTML = escapar(this.dataset.textComplete || 'Parabéns! Você ganhou todos os brindes disponíveis!');
      } else {
        var falta = this.tiers[atingidos] - valor;
        var modelo = escapar(this.dataset.textProgress || 'Adicione [falta] para ganhar.');
        this.textoEl.innerHTML = modelo.replace('[falta]', '<b>' + dinheiro(falta) + '</b>');
      }
    }
    this.classList.toggle('is-complete', completo);
    this.setAttribute('data-value', String(valor));
  };

  if (!window.customElements.get('ep-gift-bar')) window.customElements.define('ep-gift-bar', EpGiftBar);

  /* ---------- motor de brindes por faixa ---------- */
  var PROP = '_ep_brinde_faixa';
  /* mapa faixa->variante no carrinho, para a extensao de checkout (ep-cupom-brinde) saber que
     brinde colocar quando a compra sobe de faixa la dentro (upsell, cupom removido). Atributo
     com "_" na frente: nao aparece para o cliente. Formato igual ao data-gifts: "149:variante,..." */
  var ATTR_MAPA = '_ep_brindes_faixa';
  /* brindes que o cliente tirou a mao (ou que ficaram sem desconto): o checkout nao recoloca */
  var ATTR_RECUSADOS = '_ep_brindes_recusados';
  var nossaEscrita = false;      /* a escrita em curso e do motor (nao e "cliente tirou") */
  var sincronizando = false;
  var bloqueados = {};           /* variante -> 'cliente' | 'sem-desconto' | 'erro' */
  var faixaPerdida = {};         /* variante -> faixa (reais) para destravar 'cliente' ao perder a faixa */

  function configBrindes() {
    var el = document.querySelector('ep-gift-bar[data-auto-add="true"][data-gifts]');
    if (!el || !el.dataset.gifts) return null;
    var lista = [];
    el.dataset.gifts.split(',').forEach(function (par) {
      var p = par.split(':');
      var reais = Number(p[0]), variante = String(p[1] || '').trim();
      if (reais > 0 && variante) lista.push({ reais: reais, cents: reais * 100, variante: variante });
    });
    return lista.length ? { lista: lista, pixCode: String(el.dataset.pixCode || 'PIX').toUpperCase() } : null;
  }

  function escrever(url, corpo) {
    nossaEscrita = true;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
      .then(function (res) { nossaEscrita = false; return res; }, function (e) { nossaEscrita = false; throw e; });
  }

  function sincronizarBrindes(cart) {
    var cfg = configBrindes();
    if (!cfg || sincronizando || !cart || !cart.items) return;

    var itens = cart.items;
    var presentes = {};          /* variante -> true (qualquer origem) */
    var nossos = [];             /* linhas com _ep_brinde_faixa */
    var brindesTotal = 0;        /* preco final das linhas de brinde (qualquer app) */
    itens.forEach(function (it) {
      presentes[String(it.variant_id)] = true;
      var props = it.properties || {};
      if (props[PROP]) nossos.push(it);
      if (props[PROP] || props._Gifted || props._ep_brinde_cupom) brindesTotal += it.final_line_price || 0;
    });
    var base = valorBase(cart, cfg.pixCode) - brindesTotal;

    /* faixa perdida destrava o brinde que o cliente tirou a mao */
    Object.keys(faixaPerdida).forEach(function (v) {
      if (base < faixaPerdida[v] * 100) { delete bloqueados[v]; delete faixaPerdida[v]; }
    });

    var adicionar = [];
    var atualizar = {};
    cfg.lista.forEach(function (f) {
      var atingida = base >= f.cents;
      if (atingida && !presentes[f.variante] && !bloqueados[f.variante]) {
        var props = {}; props[PROP] = String(f.reais);
        adicionar.push({ id: Number(f.variante), quantity: 1, properties: props });
      }
    });
    /* nossas linhas, por variante: quando o cliente poe 2 unidades, a Shopify divide a linha
       (1 gratis + 1 cobrada, chaves diferentes); fica so a linha gratis, com 1 unidade */
    var nossosPorVariante = {};
    nossos.forEach(function (it) { var v = String(it.variant_id); (nossosPorVariante[v] = nossosPorVariante[v] || []).push(it); });
    Object.keys(nossosPorVariante).forEach(function (v) {
      var linhas = nossosPorVariante[v];
      var f = null;
      cfg.lista.forEach(function (x) { if (x.variante === v) f = x; });
      if (!f || base < f.cents) { linhas.forEach(function (it) { atualizar[it.key] = 0; }); return; } /* saiu da config ou caiu de faixa */
      var gratis = linhas.filter(function (it) { return (it.final_line_price || 0) === 0; });
      if (!gratis.length) {                                    /* desconto nao aplicou: nao cobrar o brinde */
        linhas.forEach(function (it) { atualizar[it.key] = 0; });
        bloqueados[v] = 'sem-desconto';
        if (window.console) console.warn('[brindes] desconto BRINDE nao aplicou no brinde', v, '- brinde removido');
        return;
      }
      linhas.forEach(function (it) {
        if (it !== gratis[0]) atualizar[it.key] = 0;
        else if (it.quantity > 1) atualizar[it.key] = 1;
      });
    });
    /* brinde de outro app que ficou sem desconto (app desativado): tira para nao cobrar */
    itens.forEach(function (it) {
      var props = it.properties || {};
      if (props._Gifted && !props[PROP] && (it.final_line_price || 0) > 0) atualizar[it.key] = 0;
    });

    var temUpdate = Object.keys(atualizar).length > 0;
    var mapa = cfg.lista.map(function (f) { return f.reais + ':' + f.variante; }).join(',');
    var recusados = Object.keys(bloqueados).filter(function (v) { return bloqueados[v] === 'cliente' || bloqueados[v] === 'sem-desconto'; }).sort().join(',');
    var attrs = cart.attributes || {};
    var precisaMapa = attrs[ATTR_MAPA] !== mapa || (attrs[ATTR_RECUSADOS] || '') !== recusados;
    if (!adicionar.length && !temUpdate && !precisaMapa) return;
    sincronizando = true;
    /* a linha que vai sair some da tela ja (senao aparece 1-2 s com preco cheio ate o tema reler) */
    Object.keys(atualizar).forEach(function (k) {
      if (atualizar[k] !== 0) return;
      document.querySelectorAll('cart-item[data-key="' + k + '"]').forEach(function (el) { el.style.display = 'none'; });
    });
    var passo = Promise.resolve();
    if (temUpdate || precisaMapa) passo = passo.then(function () {
      var corpo = {};
      if (temUpdate) corpo.updates = atualizar;
      if (precisaMapa) { corpo.attributes = {}; corpo.attributes[ATTR_MAPA] = mapa; corpo.attributes[ATTR_RECUSADOS] = recusados; }
      return escrever('/cart/update.js', corpo);
    });
    if (adicionar.length) passo = passo.then(function () {
      return escrever('/cart/add.js', { items: adicionar }).then(function (res) {
        if (!res.ok) {
          /* 422 = sem estoque / validacao: nao insiste nesses brindes na sessao */
          adicionar.forEach(function (i) { bloqueados[String(i.id)] = 'erro'; });
          if (window.console) console.warn('[brindes] nao foi possivel adicionar', res.status, res.json && res.json.description);
        }
      });
    });
    passo.catch(function () {}).then(function () {
      sincronizando = false;
      /* o tema so relê o carrinho sozinho na janela logo depois de uma escrita dele; fora
         dela a gaveta ficava com o carrinho velho ate o F5. Este evento (o mesmo que o BOGOS
         usava) faz o tema reler e redesenhar as linhas (scheduleSync, 500 ms). */
      document.dispatchEvent(new CustomEvent('fg-cart:auto-updated', { detail: { origem: 'ep-brindes' } }));
      agendar();
    });
  }

  /* o cliente tirou um brinde nosso a mao: nao recolocar ate a faixa cair e voltar */
  function anotarRemocaoManual(url, corpo) {
    if (nossaEscrita || !ultimoCart || !corpo) return;
    var chaves = {};
    try {
      var b = typeof corpo === 'string' ? JSON.parse(corpo) : corpo;
      if (b && b.updates && typeof b.updates === 'object') Object.keys(b.updates).forEach(function (k) { if (Number(b.updates[k]) === 0) chaves[k] = true; });
      if (b && b.id != null && Number(b.quantity) === 0) chaves[String(b.id)] = true;
      if (b && b.line != null && Number(b.quantity) === 0) { var it = ultimoCart.items[Number(b.line) - 1]; if (it) chaves[it.key] = true; }
    } catch (e) { return; }
    ultimoCart.items.forEach(function (it) {
      if (chaves[it.key] && it.properties && it.properties[PROP]) {
        var v = String(it.variant_id);
        bloqueados[v] = 'cliente';
        faixaPerdida[v] = Number(it.properties[PROP]) || 0;
      }
    });
  }

  /* leitura do carrinho e redesenho de todas as barras */
  var lendo = false;
  var pendente = false;
  function atualizar() {
    if (lendo) { pendente = true; return; }
    lendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ultimoCart = cart;
        barras.forEach(function (b) { b.desenhar(valorBase(cart, b.pixCode)); });
        sincronizarBrindes(cart);
      })
      .catch(function () {})
      .then(function () {
        lendo = false;
        if (pendente) { pendente = false; atualizar(); }
      });
  }

  var agendado = null;
  function agendar() {
    clearTimeout(agendado);
    agendado = setTimeout(atualizar, 300);
  }

  /* escritas no carrinho, do tema ou de apps */
  var ESCRITA = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;
  var fetchOriginal = window.fetch;
  window.fetch = function (entrada, init) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    if (/\/cart\/(update|change)(\.js)?(\?|$)/.test(url)) anotarRemocaoManual(url, init && init.body);
    var p = fetchOriginal.call(window, entrada, init);
    if (ESCRITA.test(url)) p.then(agendar, function () {});
    return p;
  };
  var abrirOriginal = XMLHttpRequest.prototype.open;
  var enviarOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this._epUrl = String(url);
    if (ESCRITA.test(String(url))) this.addEventListener('loadend', agendar);
    return abrirOriginal.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (corpo) {
    if (this._epUrl && /\/cart\/(update|change)(\.js)?(\?|$)/.test(this._epUrl)) anotarRemocaoManual(this._epUrl, corpo);
    return enviarOriginal.apply(this, arguments);
  };
  ['fg-cart:auto-updated', 'fg-gifts:updated', 'vindi:cart:added', 'bogos:gifts'].forEach(function (ev) {
    document.addEventListener(ev, agendar);
  });

  /* primeira leitura (o valor renderizado no Liquid pode estar defasado por cache) */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(atualizar, 600); });
  else setTimeout(atualizar, 600);
})();
